import React from 'react';
import PropTypes from 'prop-types';

import {Pill, Stack} from 'views/components';
import {translate} from 'views/module';

const MessageTypeFilter = (props) => {
  const {
    messageTypeFilter,
    setMessageTypeFilter,
  } = props;

  const filterTypeKeys = Object.keys(messageTypeFilter);
  const isAllSelected = filterTypeKeys.every((type) => messageTypeFilter[type]);

  const getFilterLabel = (type) => {
    switch (type) {
      case 'COMMENTS':
        return translate('career.jobDetail.Messages.Type.Comments');
      case 'ANNOUNCEMENTS':
        return translate('career.jobDetail.Messages.Type.Announcements');
      default:
        return type;
    }
  };

  const onFilterClick = (type) => {
    if (isAllSelected) {
      setMessageTypeFilter(filterTypeKeys.reduce((output, key) => {
        output[key] = key === type;
        return output;
      }, {}));
      return;
    }

    setMessageTypeFilter({
      ...messageTypeFilter,
      [type]: !messageTypeFilter[type],
    });
  };

  const onAllClick = () => {
    setMessageTypeFilter(filterTypeKeys.reduce((output, key) => {
      output[key] = true;
      return output;
    }, {}));
  };

  return (
    <Stack
      direction='row'
      spacing={0.75}
      sx={{
        flexWrap: 'wrap',
        rowGap: 0.75,
      }}
    >
      <Pill
        label={translate('career.jobDetail.Messages.FilterPills.All')}
        onClick={onAllClick}
        role='button'
        sx={{
          'borderRadius': '20px',
          'borderColor': isAllSelected ? '#EBBDAD' : '#E8E4DE',
          'backgroundColor': isAllSelected ? '#FFF7F4' : '#F9F8F6',
          'cursor': 'pointer',
          'height': '24px',
          'px': '12px',
          'py': '5px',
        }}
        textColor={isAllSelected ? '#DA7955' : '#6B6760'}
        labelSx={{
          fontFamily: 'inherit',
          fontSize: '12px',
          lineHeight: '14px',
        }}
      />
      {
        filterTypeKeys.map((type) => {
          const selected = !isAllSelected && Boolean(messageTypeFilter[type]);

          return (
            <Pill
              key={type}
              label={getFilterLabel(type)}
              onClick={() => onFilterClick(type)}
              role='button'
              sx={{
                'borderRadius': '20px',
                'borderColor': selected ? '#EBBDAD' : '#E8E4DE',
                'backgroundColor': selected ? '#FFF7F4' : '#F9F8F6',
                'cursor': 'pointer',
                'height': '24px',
                'px': '12px',
                'py': '5px',
              }}
              textColor={selected ? '#DA7955' : '#6B6760'}
              labelSx={{
                fontFamily: 'inherit',
                fontSize: '12px',
                lineHeight: '14px',
              }}
            />
          );
        })
      }
    </Stack>
  );
};

MessageTypeFilter.propTypes = {
  messageTypeFilter: PropTypes.shape({
    ANNOUNCEMENTS: PropTypes.bool.isRequired,
    COMMENTS: PropTypes.bool.isRequired,
  }).isRequired,
  setMessageTypeFilter: PropTypes.func.isRequired,
};

export default React.memo(MessageTypeFilter);
